import styled from 'styled-components';
import Box, { BoxProps } from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { Breakpoints } from '@material-ui/core/styles/createBreakpoints';
import { Actions } from '../actions';

import { WithMyTheme } from '@keaze/web/theme';

interface AvailableProps extends WithMyTheme {
  $isSold?: boolean;
}

interface StartRegistrationProps extends WithMyTheme {
  $singleProperty: boolean;
  $isSold: boolean;
}

export const Table = styled(Box)`
  ${({ theme: { breakpoints } }) => `
    position: relative;

    ${breakpoints.up('md')} {
      // margin-top: 25px;
    }
  `}
`;

export const TableCell = styled(Box)`
  ${({
    theme: {
      palette,
      typography: { body2 },
      colors,
      breakpoints,
    },
  }) => `
    position: relative;
    display: flex;
    color: ${colors.greens.green0};
    ${breakpoints.up('md')} {    font-size: 18px;}
    font-size: px;
    margin-bottom: 10px;
    line-height: ${body2.lineHeight};
    font-weight: ${body2.fontWeight};
    opacity: 1;

    &:first-child {
      padding-right: 10px;
      ${breakpoints.up('md')} { width: 70%;}
     width: 65%;
   
    }

    &:last-child {
      padding-left: 10px;
      ${breakpoints.up('md')} { width: 30%;}
      width: 35%;

    }
  `}
`;

export const TableRow = styled(Box)`
  ${({ theme: { palette } }) => `
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;

    &::after {
      content: '';
      position: absolute;
      bottom: 6px;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: ${palette.text.primary};
      opacity: 0.07;
      z-index: -1;
    }

    &:first-child {
      ${TableCell} {
        font-weight: 600;
        opacity: 1;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const Header = styled(Box)`
  ${({ theme: { colors, breakpoints } }) => `
  
    // left: 0;
    // bottom: 0;
    // width: 100%;
    // padding: 20px;
    // background-color: ${colors.greys.greys5};
    // display: flex;
    // flex-direction: column;
  

    
    // padding-bottom: calc(20px + env(safe-area-inset-bottom));

    ${breakpoints.up('md')} {
  
      width: 100%;
      padding: 0;
      background-color: transparent;
    }

    ${breakpoints.up('lg')} {
      flex-direction: row;
      align-items: center;

      ${Info} {
        order: 1;
    
      }

      ${RegisterButton} {
        order: 0;
      }
    }
  `}
`;

const startRegistrationSoldStyles = (breakpoints: Breakpoints) => `
  ${Info} {
    order: 0;
    text-align: center;
    margin: 0 0 15px 0;

    ${breakpoints.up('md')} {
      text-align: left;
    }
  
    ${breakpoints.up('lg')} {
      order: 1;
      margin: 0 0 0 10px;
    }
  }

`;

export const StartRegistration = styled(Box)<StartRegistrationProps & BoxProps>`
  ${({ theme: { colors, breakpoints }, $singleProperty, $isSold }) => `

    padding: ${$singleProperty ? '20px 0' : ''};
    display: flex;
    flex-direction: column;
    bottom: 14rem;
    border-radius: 0px 0px 60px 0px;
    border: 1px solid #672500;
    height: 213px;
    width: 100%;
    background-color: ${colors.golds.gold1};
    ${breakpoints.up('sm')} {
      &::before {
        left: -24px;
        width: calc(100vw + 24px);
      }
    }

    ${breakpoints.up('md')} {
      padding: 20px;
      background-color: ${colors.golds.gold1};
      z-index: 0;
    }

    ${$isSold ? startRegistrationSoldStyles(breakpoints) : ''};
  `}
`;

export const Info = styled(Box)`
  ${({ theme: { breakpoints } }) => `
    flex: 1 1 100%;
li {   justify-content: center;}
 


    ${breakpoints.up('md')} {
      margin-bottom: 10px;
      display: block;
      li {   justify-content: unset;}
    }

    ${breakpoints.up('lg')} {
      margin-bottom: 0;
    }
  `}
`;

export const Available = styled(Typography)<TypographyProps & AvailableProps>`
  ${({ theme: { palette }, $isSold }: AvailableProps) => `
    color: ${$isSold ? palette.secondary.dark : palette.text.primary} ;
    display: flex;
    position: relative;
    width: 250px;
    color: #672500;
    font-size: 18px;
    .priceAvailable {
      margin-left: 1rem;
      margin-top: -0.1rem;
      color: #672500;
      font-size: 18px;
    }
    .depositAvailable {
      color: #672500;
      font-size: 18px;
      padding-left: 1rem;
    }
  `}
`;

export const Price = styled(Typography)`
  font-weight: 700;
  font-size: 18px;
  color: #672500
  position: relative;
`;

export const AvailableWrapper = styled(Box)`
  h2 {
    position: relative;
    bottom: 1.5rem;
    right: 14rem;
    color: #672500;
    font-size: 24px;
    font-weight: 700;
  }
  ${Price} {
    margin: 0 -2px;
  }
`;

export const AvailableGroup = styled(Box)`
  display: flex;
  flex-direction: row;
  position: relative;
  right: 14rem;
  bottom: 1.3rem;
`;

export const AvailableGroupSecondary = styled(Box)`
  display: flex;
  flex-direction: row;
  position: relative;
  right: 14rem;
  bottom: 1rem;
`;

export const RegisterButton = styled(Button)`
  ${({ theme: { breakpoints } }) => `

    width: 214px;
    height: 53px;
    margin: 0 auto;
    border-radius: 29.5px !important;
    background: #672500;
    ${breakpoints.up('md')} {
    }
  `}
`;

export const StyledActions = styled(Actions)`
  ${({ theme: { breakpoints } }) => `
  
    ${breakpoints.up('md')} {
      display: none;
    }
  `}
`;
